import { connect } from 'react-redux';
import { compose } from 'recompose';
import { bindActionCreators } from 'redux';
import { isPristine, isValid, submit } from 'redux-form';
import { getLoader } from '@topconagriculture/loader';
import { ProfilingForms, ProfilingLoaders } from '../../config';
import { getUserApps, getUserProfile, updateUserProfile } from '../../store';
import UserModal from './UserModal';
const formId = ProfilingForms.editUserProfile;
const mapStateToProps = (state) => {
    const isFetchingUser = getLoader(state)(ProfilingLoaders.userIsRetrievingProfile);
    const isFetchingCompany = getLoader(state)(ProfilingLoaders.fetchCompany);
    const isUpdatingUserProfile = getLoader(state)(ProfilingLoaders.updatingUserProfile);
    return {
        disabled: !isValid(formId)(state) || isPristine(formId)(state),
        user: getUserProfile(state),
        userApps: getUserApps(state),
        isEditingProfile: isUpdatingUserProfile,
        isLoadingUserData: isFetchingCompany && isFetchingUser,
    };
};
const mapDispatchToProps = (dispatch) => bindActionCreators({
    updateProfile: updateUserProfile.started,
    submit,
}, dispatch);
export default compose(connect(mapStateToProps, mapDispatchToProps))(UserModal);
//# sourceMappingURL=UserModalContainer.js.map